import { ICON_DEFAULTS, ICON_PATHS, type IconProps } from '../constants/icons'
import { cx } from '../helpers/format'

export function Icon({
  name,
  size = ICON_DEFAULTS.size,
  strokeWidth = ICON_DEFAULTS.strokeWidth,
  filled = false,
  className,
}: IconProps) {
  return (
    <svg
      className={cx('icon', className)}
      width={size}
      height={size}
      viewBox={ICON_DEFAULTS.viewBox}
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
    >
      {ICON_PATHS[name].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  )
}
